// 货站转单高级弹窗配置
export const stationConfig = {
    name: '货站转单',
    value: 'stationName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'stationName', value: '货站名称' },
        { prop: 'stationCode', value: '货站编码' }
    ],
    tableConfig: [
        { prop: 'stationCode', value: '货站编码' },
        { prop: 'stationName', value: '货站名称' },
        { prop: 'contactsName', value: '货站联系人姓名' },
        { prop: 'contactsMobile', value: '货站联系人电话' },
        { prop: 'supplierName', value: '承运商名称' },
        { prop: 'supplierCode', value: '承运商编码' },
    ],
    prefix: '/api-antms/transport',
    advanceUrl: '/lsp/transfer/getStationList',
    method: 'post',
    paramType: true,
    cbParams: ['stationCode#stationCode', 'stationName#stationName', 'contactsName', 'contactsMobile', 'supplierCode','supplierName'],
    advanceCascade: 'supplierCode',
}
